export const orders = [
  {
    restaurant: "Melenzane",
    date: "19/12/2024",
    items: [
      { name: "1x Milly Gathering", price: "KWD 18.000" },
      { name: "2x Pollo Pazzo ", price: "KWD 7.700" },
      { name: "1x Pomodoro Zuppa", price: "KWD 2.550" },
    ],
    total: "KWD 28.250",
    status: "Preparing",
  },
  {
    restaurant: "Trapani",
    date: "14/07/2024",
    items: [
      { name: "1x Milly Gathering", price: "KWD 18.000" },
      { name: "2x Pollo Pazzo ", price: "KWD 7.700" },
      { name: "1x Pomodoro Zuppa", price: "KWD 2.550" },
    ],
    total: "KWD 28.250",
    status: "Re-Order",
  },
  {
    restaurant: "Cafeteria Al Dhahiya",
    date: "06/05/2024",
    items: [
      { name: "1x Milly Gathering", price: "KWD 18.000" },
      { name: "2x Pollo Pazzo ", price: "KWD 7.700" },
      { name: "1x Pomodoro Zuppa", price: "KWD 2.550" },
    ],
    total: "KWD 28.250",
    status: "Re-Order",
  },
];
